import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";

import star from "@fortawesome/fontawesome-free-solid/faStar";
import starHalf from "@fortawesome/fontawesome-free-solid/faStarHalf";

class Review extends Component {
  constructor(props) {
    super(props);

    this.state = { stars: [], halfStars: [] };
  }

  componentDidMount() {
    const { rating } = this.props,
      fullHalfStars = String(rating).split("."),
      starLength = fullHalfStars[0],
      halfStars = !!fullHalfStars[1] ? 1 : 0,
      stars = [];

    for (var i = 0; i < starLength; i++) {
      stars.push(
        <FontAwesomeIcon key={i} icon={star} size='sm' className='star' />
      );
    }

    for (var j = 0; j < halfStars; j++) {
      stars.push(
        <FontAwesomeIcon key={j} icon={starHalf} size='sm' className='star' />
      );
    }

    this.setState({ stars, halfStars });
  }
  render() {
    const { text, reviewer } = this.props;
    return (
      <blockquote className='blockquote text-left'>
        <p className='mb-0'>{text}</p>
        <footer className='blockquote-footer'>
          {" "}
          {reviewer} <cite title='Source Title'>Google Reviews</cite>
          <div className='stars'>
            {this.state.stars.map((star) => star)}
            {this.state.halfStars.length
              ? this.state.halfStars.map((star) => star)
              : null}
          </div>
        </footer>
      </blockquote>
    );
  }
}

export default Review;



// WEBPACK FOOTER //
// ./src/components/Review.jsx